import { render } from "./FundingTraining.vue?vue&type=template&id=37726f78&scoped=true"
import script from "./FundingTraining.vue?vue&type=script&lang=js"
export * from "./FundingTraining.vue?vue&type=script&lang=js"

import "./FundingTraining.vue?vue&type=style&index=0&id=37726f78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37726f78"]])

export default __exports__